import React from 'react';
import headerLogo from 'assets/img/logo_200x40px Amarillo.png';
import classes from './Header.module.scss';

const Header = () => (
  <header className={classes.header}>
    <img src={headerLogo} alt="Epicland" className={classes.headerImage} />
  </header>
);

export default Header;
